import getExtensibilityState from '../store/getExtensibilityState';
import TaskPaneType from '../store/schema/TaskPaneType';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('terminateTaskPaneAddin', function terminateTaskPaneAddin(
    type: TaskPaneType
) {
    getExtensibilityState().taskPanes.delete(type);
});
